import {TemplateState} from "@generated"
import {StateLabel} from "@platform/models/state-labels/state-label"

export const TemplateStateLabels: Map<TemplateState, StateLabel<TemplateState>> = new Map<TemplateState, StateLabel<TemplateState>>([
    [TemplateState.Draft, {state: TemplateState.Draft, label: "Draft", background: "#989898"}],
    [TemplateState.InProgress, {state: TemplateState.InProgress, label: "In progress", background: "#ffab4a"}],
    [TemplateState.Review, {state: TemplateState.Review, label: "Review", background: "#7cbcb0"}],
    [TemplateState.Completed, {state: TemplateState.Completed, label: "Completed", background: "#7ec17a"}],
])
